"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toRectOnCanvas = void 0;
/**
 * @description
 * 画像上の長方形位置をキャンバス上の位置に変換する．
 */
var toRectOnCanvas = function (imgRect) { return function (rect) {
    return rect.withMutations(function (from) {
        return from
            .update('left', function (l) { return l + imgRect.left; })
            .update('top', function (t) { return t + imgRect.top; });
    });
}; };
exports.toRectOnCanvas = toRectOnCanvas;
